import { Component,Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AccessLogModel } from '../model/access-log.model';


@Component({
  selector: 'app-access-log-view-dialog',
  standalone: false,
  templateUrl: './access-log-view-dialog.component.html',
  styleUrl: './access-log-view-dialog.component.scss'
})
export class AccessLogViewDialogComponent {
formattedData: string;

  constructor(public dialogRef: MatDialogRef<AccessLogViewDialogComponent>,
      @Inject(MAT_DIALOG_DATA)  public data: { accessLogData: AccessLogModel }) {
      // Update view with given values
      this.formattedData = this.formatJsonData(data.accessLogData.data);
    
    }
formatJsonData(data: any): string {
  if (!data) {
    return '';
  }

  try {
    const jsonObj = typeof data === 'string' ? JSON.parse(data) : data;

    if (!Object.keys(jsonObj).length) {
      return '';
    }

    return Object.entries(jsonObj)
      .map(([key, value]) => `${key}: ${value}`)
      .join('\n');
  } catch (e) {
    return '';
  }
}


    onClose(): void {
    this.dialogRef.close();
  }
  

}
